import { CustomField, ExportPayload } from '../types/dataExport.types';
import { axiosHub } from '../../../../../services/config/axiosHub.config';
import { HubApi } from '@services';

export const fetchWorkflows = async (organizationId: string, signal?: AbortSignal) => {
  return await HubApi.Workflow.getWorkflows({ organizationId, limit: 100 });
};

export const fetchCustomFields = async (organizationId: string, signal?: AbortSignal): Promise<CustomField[]> => {
  const { data } = await axiosHub.get<CustomField[]>(`/api/v1/crm/custom-fields`, {
    params: { organizationId, entity: 'creditRequestItem,ticket' },
    signal,
  });
  return data;
};

export const fetchCustomFieldsWithSearch = async (organizationId: string, searchTerm?: string): Promise<CustomField[]> => {
  const params: any = { organizationId, entity: 'creditRequestItem,ticket' };
  if (searchTerm) params.search = searchTerm;
  const { data } = await axiosHub.get<CustomField[]>('/api/v1/crm/custom-fields', { params });
  return data;
};

export const fetchOrganizationBranches = async (organizationId: string) => {
  const { data } = await axiosHub.get(`/api/v1/crm/organization-branches/organizations/${organizationId}`);
  return data;
};

export const fetchSeasonIntervals = async (organizationId: string) => {
  const { data } = await axiosHub.get(`/api/v1/season-intervals`, { params: { organizationId } });
  return data;
};

export const exportData = async (payload: ExportPayload): Promise<Blob> => {
  const { data } = await axiosHub.post('/api/v1/crm/credit-requests/export', payload, { responseType: 'blob' });
  return data;
};
